var React = require('react');

function IconNo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 6c5.514 0 10 4.486 10 10s-4.486 10-10 10S6 21.514 6 16 10.486 6 16 6zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm-3.293 3.293l3.364 3.363 3.364-3.363a1 1 0 011.414 1.414l-3.364 3.364 3.364 3.364a1 1 0 01-1.414 1.414l-3.364-3.364-3.364 3.364a1 1 0 01-1.414-1.414l3.363-3.364-3.363-3.364a1 1 0 011.414-1.414z","fillRule":"evenodd"}));
}

IconNo.defaultProps = {"height":"32","width":"32"};

module.exports = IconNo;

IconNo.default = IconNo;
